export default __webpack_public_path__ + "static/media/mens_ministry.d8dd4490.jpg";